import { createAsyncThunk } from "@reduxjs/toolkit";
import { SmarticoRaffle, SmarticoRaffleDraw, TRaffleDrawRun } from "../interfaces/SmarticoRaffle";
import { createAppAsyncThunk } from "../../../hooks";
import { smarticoRaffleSlice } from "./slice";

export const getSmarticoRaffles = createAsyncThunk("smarticoRaffle/getRaffles", async (api: () => Promise<any>) => {
  const _api = await api();
  return _api.getRaffles() as SmarticoRaffle[];
});

export const getDrawRunHistory = createAppAsyncThunk<
  TRaffleDrawRun[][],
  { draw_ids?: number[]; api: () => Promise<any> }
>("smarticoRaffle/getDrawRunHistory", async (params, { getState }) => {
  const state = getState();
  const { draw_ids, api } = params;
  const _api = await api();
  const finalResponse: TRaffleDrawRun[][] = [];
  const correctDrawIds = draw_ids.filter(
    id => state[smarticoRaffleSlice.name].raffle.draws.findIndex(draw => draw.id === id) !== -1
  );
  for (const draw_id of correctDrawIds) {
    const callParams: { raffle_id: number; draw_id?: number } = {
      raffle_id: state[smarticoRaffleSlice.name].raffleId || 84,
    };
    if (draw_id) {
      callParams.draw_id = draw_id;
    }
    finalResponse.push(await _api.getRaffleDrawRunsHistory(callParams));
  }
  return finalResponse;
});

export const getDrawRunWinners = createAppAsyncThunk<
  SmarticoRaffleDraw,
  {
    run_id: number;
    api: () => Promise<any>;
    from?: number;
    to?: number;
    append?: boolean;
  }
>("smarticoRaffle/getDrawRunWinners", async (params, { getState }) => {
  const { run_id, api, from = 0, to = 8 } = params;
  const state = getState();
  const raffleId = state[smarticoRaffleSlice.name].raffleId || 84;
  const _api = await api();

  return _api.getRaffleDrawRun({
    raffle_id: raffleId,
    run_id,
    winners_from: from,
    winners_to: to,
  }) as Promise<SmarticoRaffleDraw>;
});
